// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"39c54491","779":"5eb758c8","866":"a5f72b31"}[chunkId] + ".chunk.js";
};